import UserDemographicList from './UserDemographicList';
export default UserDemographicList;